// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMediaCamDefault_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M11 0H5L4 2H12L11 0Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M8 12C9.65685 12 11 10.6569 11 9C11 7.34315 9.65685 6 8 6C6.34315 6 5 7.34315 5 9C5 10.6569 6.34315 12 8 12ZM8 10C8.55228 10 9 9.55228 9 9C9 8.44772 8.55228 8 8 8C7.44772 8 7 8.44772 7 9C7 9.55228 7.44772 10 8 10Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M16 3H0V15H16V3ZM14 5H2V13H14V5Z" class="svg-bg"/>
</svg>
`;
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M7 2H17L18 4H6L7 2Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M16 14C16 16.2091 14.2091 18 12 18C9.79086 18 8 16.2091 8 14C8 11.7909 9.79086 10 12 10C14.2091 10 16 11.7909 16 14ZM14 14C14 15.1046 13.1046 16 12 16C10.8954 16 10 15.1046 10 14C10 12.8954 10.8954 12 12 12C13.1046 12 14 12.8954 14 14Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M24 6H0V22H24V6ZM22 8H2V20H22V8Z" class="svg-bg"/>
</svg>
`;
const _s32IconSvg = html `<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M22 3H10L9 5H23L22 3Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M16 23C18.7614 23 21 20.7614 21 18C21 15.2386 18.7614 13 16 13C13.2386 13 11 15.2386 11 18C11 20.7614 13.2386 23 16 23ZM16 21C17.6569 21 19 19.6569 19 18C19 16.3431 17.6569 15 16 15C14.3431 15 13 16.3431 13 18C13 19.6569 14.3431 21 16 21Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M32 7H0V29H32V7ZM30 9H2V27H30V9Z" class="svg-bg"/>
</svg>
`;
const _s40IconSvg = html `<svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M28 4H12L11 6H29L28 4Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M20 29C23.866 29 27 25.866 27 22C27 18.134 23.866 15 20 15C16.134 15 13 18.134 13 22C13 25.866 16.134 29 20 29ZM20 27C22.7614 27 25 24.7614 25 22C25 19.2386 22.7614 17 20 17C17.2386 17 15 19.2386 15 22C15 24.7614 17.2386 27 20 27Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M0 8V36H40V8H0ZM38 10H2V34H38V10Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMediaCamDefault is a generated icon component.
 */
let IconMediaCamDefault = IconMediaCamDefault_1 = class IconMediaCamDefault extends IconBaseElement {
    render() {
        return html `${IconMediaCamDefault_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMediaCamDefault.icons = new Map([
    ['s8', _s16IconSvg],
    ['s12', _s16IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s32IconSvg],
    ['s40', _s40IconSvg],
    ['s48', _s40IconSvg],
    ['s64', _s40IconSvg],
    ['s72', _s40IconSvg],
    ['s80', _s40IconSvg],
]);
IconMediaCamDefault = IconMediaCamDefault_1 = __decorate([
    customElement('zui-icon-media-cam-default')
], IconMediaCamDefault);
export { IconMediaCamDefault };
